import React from 'react';
import {
  avatarColorForName,
  formatTipCredit,
  initialLetter,
  maskPhone,
  transactionDisplayName
} from '../utils/transactionDisplay';

export function TransactionListRow({ transaction, onViewDetails }) {
  const displayName = transactionDisplayName(transaction);
  const letter = initialLetter(displayName);
  const bg = avatarColorForName(displayName);
  const phoneLine = transaction.customerPhone ? maskPhone(transaction.customerPhone) : '';

  return (
    <div className="tx-item-card">
      <div className="tx-item-main">
        <div className="tx-item-avatar" style={{ backgroundColor: bg }} aria-hidden="true">
          {letter}
        </div>
        <div className="tx-item-text">
          <div className="tx-item-name">{displayName}</div>
          {phoneLine ? <div className="tx-item-phone">{phoneLine}</div> : null}
        </div>
      </div>
      <div className="tx-item-right">
        <div className="tx-item-amount">{formatTipCredit(transaction.amount)}</div>
        <button
          type="button"
          className="tx-item-details-link"
          onClick={() => onViewDetails(transaction)}
        >
          View Details
        </button>
      </div>
    </div>
  );
}
